import { DOCUMENT } from '@angular/common';
import { type Injector } from '@angular/core';
import { ImpersonationStore } from '@sds/shared';

export async function impersonationInitializer(injector: Injector): Promise<void> {
  const document = injector.get(DOCUMENT);
  const urlParams = new URLSearchParams(document.location.search);
  const externalId = urlParams.get('impersonateExternalId');
  const userId = urlParams.get('impersonateUserId');

  // If both impersonation parameters are present, start impersonation
  if (externalId && userId) {
    const impersonationStore = injector.get(ImpersonationStore);

    // Start impersonation - this will call the API and reload the page
    impersonationStore.startImpersonation({
      externalId,
      userId: Number(userId)
    });

    // Remove the parameters from URL to clean it up (before reload)
    const url = new URL(document.location.href);
    url.searchParams.delete('impersonateExternalId');
    url.searchParams.delete('impersonateUserId');
    document.defaultView?.history.replaceState({}, '', url.toString());
  }
}
